import ActionTypes from "../constants/action_types";

export default function clearSecondaryDocument() {
  return {
    type: ActionTypes.SECONDARY_DOCUMENT_CLEAR.SUCCESS,
  };
}
